let _accountId;
let _stage;
let _getAccessToken = () => '';

// Account Id for the user
const getAccountId = () => _accountId;

// The stage for the client, 'alpha' || 'beta' || 'prod'
const getStage = () => _stage;

// The function to retrieve a users Cognito token
const getAccessToken = async () => _getAccessToken();

const setAccountId = accountId => {
    if (_accountId !== accountId) _accountId = accountId;
};

const setStage = stage => {
    if (_stage !== stage) _stage = stage;
};

const setGetAccessToken = getToken => {
    if (_getAccessToken !== getToken) _getAccessToken = getToken;
};

/*
 * Configuration that all loaders need
 */
const setConfig = (stage, accountId, getToken) => {
    // TODO: how are we handling multiple account ids?
    const firstAccountId = accountId || '';

    setAccountId(firstAccountId);
    setStage(stage);
    setGetAccessToken(getToken);
};

const VENUE_OBJECT_TYPES = {
    ORDINAL: 'ordinals',
    STRUCTURE: 'structures',
    LEVEL: 'levels',
    VENUE: 'venue',
};

export { getAccessToken, getAccountId, getStage, setConfig, VENUE_OBJECT_TYPES };
